import React, { Component } from "react";
import axios from "axios";
import SignupConfirmation from "./SignupConfirmation";

class EmailSignup extends Component {
    constructor() {
        super();
        this.onSubmit = this.onSubmit.bind(this);
        this.closeConfirmation = this.closeConfirmation.bind(this);
        this.emailField = React.createRef();
        this.state = {
            confirmationVisible: false
        }
    }

    onSubmit(e) {
        e.preventDefault();

        axios.post("/wp-json/vv/email/signup", {
            email: this.emailField.current.value
        }).then(resp => {
            this.setState({ confirmationVisible: true });
        }).catch(error => {
            console.log(error);
        })
    }

    closeConfirmation() {
        console.log("close it");
        this.setState({
            confirmationVisible: false
        })
    }

    render() {
        return <div className="email-signup">
            <h3 className="title">get 10% off your first order</h3>
            <span className="text">Start receiving new product alerts, inspirational content and information on events straight to your inbox.</span>

            <form className="email-signup-form" onSubmit={this.onSubmit}>
                <input type="email" className="email-input" placeholder="Enter your email..." ref={this.emailField} />
                <button type="submit" className="submit-btn">Submit</button>
            </form>

            <SignupConfirmation visible={this.state.confirmationVisible}
                    closeConfirmation={this.closeConfirmation} />
        </div>
    }
}

export default EmailSignup;